import PaymentAttributeDetailList from '@/controllers/payment_att_detail/payment-attribute-detail-list.js';

export default {
  extends: PaymentAttributeDetailList,
}
